module.exports = __webpack_public_path__ + "static/media/sala-comedor-2.19583b72.jpg";